import React, { useEffect, useState } from 'react';
import { arrayMove, SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';
import { Box, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { DndContextWrapper } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/DragAndDrop';
import SectionHeader from '@monorepo/shared/src/components/layout/SectionHeader';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import WithQuery from '@monorepo/shared/src/components/common/WithQuery';
import useTeachingOrderStore from 'graph/state/query-hooks/use-teaching-order';
import useTeachingOrder from 'state/hooks/use-teaching-order';
import useTrialUserOmitRoutes from 'state/hooks/use-trial-user-omit-routes';
import EditTeachingOrderFooter from './components/EditTeachingOrderFooter';
import EditTeachingOrderSelector from './components/EditTeachingOrderSelector';
import { EditTeachingOrderSortableItem } from './components/EditTeachingOrderSortableItem';

const t = (key) => translate('teachingOrder', key);

const EMPTY_TAG = ' ';

const EditTeachingOrder: React.FC = () => {
  const [{ activeCharacters, resetSignal }, { handleCardChange }] = useTeachingOrder();
  const [{ isLoading, error }] = useTeachingOrderStore();
  const [items, setItems] = useState([] as any);
  const classes = useStyles();
  const omitRoutes = useTrialUserOmitRoutes();

  useEffect(() => {
    const characters = activeCharacters.map((charObj) => charObj.character);
    if (characters) {
      characters.push(EMPTY_TAG);
    }
    setItems(characters);
  }, [activeCharacters, resetSignal]);

  function handleDragEnd(event, type, index) {
    const { active, over } = event;
    if (type || active?.id !== over?.id) {
      let oldIndex;
      let newIndex;

      setItems((items) => {
        if (type) {
          oldIndex = index;
          if (type === 'right') newIndex = oldIndex + 1;
          if (type === 'left') newIndex = oldIndex - 1;
        } else {
          oldIndex = items.indexOf(active.id);
          newIndex = items.indexOf(over.id);
        }
        let characters = arrayMove(items, oldIndex, newIndex);
        characters = characters.filter((x) => x != EMPTY_TAG);
        handleCardChange(characters as string[]);
        return characters;
      });
    }
  }

  return (
    <>
      <SectionHeader title={t('header')} omitRoutes={omitRoutes} />
      <WithQuery loading={isLoading} error={error}>
        <Box style={{ margin: '50px' }}>
          <EditTeachingOrderSelector />
          <Box
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              flexDirection: 'column',
            }}
          >
            {items?.length && (
              <DndContextWrapper useCollisionDetection handleOnDragEnd={handleDragEnd as any}>
                <SortableContext items={items} strategy={rectSortingStrategy}>
                  <Grid container spacing={1} className={classes.grid}>
                    {items.map((item, index) => {
                      const visible = item !== EMPTY_TAG;
                      return (
                        <EditTeachingOrderSortableItem
                          key={item}
                          item={item}
                          index={index}
                          handleCardChange={handleDragEnd}
                          arrayLength={items.length}
                          visible={visible}
                        />
                      );
                    })}
                  </Grid>
                </SortableContext>
              </DndContextWrapper>
            )}
          </Box>
        </Box>
        <EditTeachingOrderFooter />
      </WithQuery>
    </>
  );
};

const useStyles = makeStyles(() => ({
  grid: {
    flexGrow: 1,
  },
}));

export default EditTeachingOrder;
